module.exports = __webpack_public_path__ + "static/media/37-1.809d33f4.mp3";